import portfolioMediaJson from './portfolioMedia.json';

export type PortfolioMediaGroup = 'ai' | 'shoot-edit' | 'grading';
export type PortfolioMediaOrientation = 'wide' | 'vertical' | 'square';

export type PortfolioMediaItem = {
  slug: string;
  group: PortfolioMediaGroup;
  title: string;
  category: string;
  description: string;
  sourceName: string;
  videoUrl: string;
  coverUrl: string;
  width: number;
  height: number;
  duration: number;
  orientation: PortfolioMediaOrientation;
};

export const portfolioMedia = portfolioMediaJson as PortfolioMediaItem[];
export const aiWorks = portfolioMedia.filter((item) => item.group === 'ai');
export const shootingWorks = portfolioMedia.filter((item) => item.group === 'shoot-edit');
export const gradingWorks = portfolioMedia.filter((item) => item.group === 'grading');

export const formatMediaDuration = (duration: number) => {
  const minutes = Math.floor(duration / 60);
  const seconds = Math.floor(duration % 60);
  return minutes > 0 ? `${minutes}:${String(seconds).padStart(2, '0')}` : `${seconds}s`;
};
